import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles/global.css";

// Default theme
const saved = localStorage.getItem("wgm-theme") || "sme-dark";
document.documentElement.setAttribute("data-theme", saved);

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
